import {
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Button,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useAppSelector } from 'src/redux/hooks'
import { getOpenLanguages } from 'src/view-models/Languages'
import { MdLanguage } from "react-icons/md";
import { getPatientQuestions, getQuestions } from 'src/view-models/Question'
import { useLocation, useParams } from 'react-router-dom'
import Loading from 'src/components/loading/Loading'
import { RiLoader2Fill } from 'react-icons/ri'

interface Props {
    setIsLoadingTranslate?: React.Dispatch<React.SetStateAction<boolean>>
    isLoadingTranslate?:boolean
}

const LanguagesBar : React.FC<Props> = ({setIsLoadingTranslate,isLoadingTranslate}) => {
    const dispatch = useDispatch()
    const { pathname } = useLocation();
    const localStorageLanguage = localStorage.getItem("language")
    const { patientLanguage } = useAppSelector((state) => state.question)

    const [patienteLanguage, setPatienteLanguage] = useState<{ code: string, name: string } | null>(localStorageLanguage ? JSON.parse(localStorageLanguage) : patientLanguage ? patientLanguage : null)

    const { openLanguages } = useAppSelector((state) => state.language)
    const { id } = useParams()

    const [isLoading, setIsLoading] = useState(true)
    useEffect(() => {
        const fetchQuestions = async () => {
            await getOpenLanguages(dispatch)
            setIsLoading(false)
        }
        fetchQuestions()
    }, [])

    const handleChangeLanguage = async (language: { code: string, name: string }) => {
        setIsLoadingTranslate && setIsLoadingTranslate(true)
        if (pathname === "/admin/questions/patiente-view") {
            const response = await getQuestions(dispatch, language.code)
            if (response.status === true) {
                setPatienteLanguage(language)
                localStorage.setItem("language", JSON.stringify(language))
            }
        } else {
            const response = await getPatientQuestions(id!, language.code, dispatch)
            if (response?.status === true) {
                setPatienteLanguage(language)
                localStorage.setItem("language", JSON.stringify(language))
            }
            // window.location.reload()
        }
        setIsLoadingTranslate && setIsLoadingTranslate(false)
    }

    if (isLoading) {
        return <></>
    }

    return (
        <Menu>
            <MenuButton
                as={Button}
                aria-label='Options'
                rightIcon={<MdLanguage />}
                variant='outline'
                isDisabled={isLoadingTranslate}
            >
                {isLoadingTranslate ? (
                    <>
                        <RiLoader2Fill size={20} className='animate-spin' />
                    </>
                ) : patienteLanguage ? patienteLanguage.name : "Langue"}
            </MenuButton>
            <MenuList >
                {openLanguages && openLanguages?.length > 0 && openLanguages?.map((language, index) => (
                    <MenuItem
                        key={index}
                        onClick={() => handleChangeLanguage({ code: language?.code, name: language?.name })}
                        sx={{ background: language?.name === "sdsd" ? "#d6d6d6" : "transparent" }}
                    >{language?.name}
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    )
}

export default LanguagesBar